import React, { useImperativeHandle, useRef, forwardRef } from 'react';

import {
  HalfMarked,
  CheckboxContainer,
  Marked,
  Marker,
  RadioContainer,
} from './styles';
import { CheckboxProps, RadioProps } from './types';

export interface SelectionControlRef {
  focus: () => void;
  blur: () => void;
}

export const Checkbox = forwardRef<SelectionControlRef, Partial<CheckboxProps>>(
  (
    {
      disabled = false,
      state = 'unmarked',
      size = 'normal',
      style,
      className,
      onClick,
      onMouseEnter,
      onMouseLeave,
    },
    ref,
  ) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [focusState, setFocusState] = React.useState<'indie' | 'hover'>(
      'indie',
    );

    useImperativeHandle(
      ref,
      () => ({
        focus: () => setFocusState('hover'),
        blur: () => setFocusState('indie'),
      }),
      [],
    );

    return (
      <CheckboxContainer
        ref={containerRef}
        style={style}
        className={className}
        disabled={disabled}
        data-disabled={disabled}
        size={size}
        state={state}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-focus={focusState === 'hover'}
      >
        {state !== 'unmarked' && (
          <Marker>{state === 'marked' ? <Marked /> : <HalfMarked />}</Marker>
        )}
      </CheckboxContainer>
    );
  },
);

export const Radio = forwardRef<SelectionControlRef, Partial<RadioProps>>(
  (
    {
      disabled = false,
      state = 'unmarked',
      size = 'normal',
      style,
      className,
      onMouseEnter,
      onMouseLeave,
    },
    ref,
  ) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [focusState, setFocusState] = React.useState<'indie' | 'hover'>(
      'indie',
    );

    useImperativeHandle(
      ref,
      () => ({
        focus: () => setFocusState('hover'),
        blur: () => setFocusState('indie'),
      }),
      [],
    );

    return (
      <RadioContainer
        ref={containerRef}
        style={style}
        className={className}
        disabled={disabled}
        data-disabled={disabled}
        size={size}
        state={state}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-focus={focusState === 'hover'}
      >
        {state !== 'unmarked' && (
          <Marker>
            <Marked />
          </Marker>
        )}
      </RadioContainer>
    );
  },
);

export default {
  Radio,
  Checkbox,
};
